















































import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { usePartnerStore } from "@/admin/store/partner";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class PartnerSettingsNavigation extends Vue {
  @Prop() activeTab: string;
  @Prop() navigate: (args: {tab: string}) => Location;
  @Prop() partnerId: number;

  featureFlagStore = useFeatureFlagStore();
  partnerStore = usePartnerStore();
  rolePermissionsStore = useRolePermissionsStore();

  created (): void {
    this.partnerStore.loadPartnerInvestmentThresholds(this.partnerId);
  }

  get isAccountMigrationAllowed () {
    if (!this.partnerStore.investmentThresholdLoaded) {
      return false;
    }
    return this.partnerStore.isHsabCustodian(this.partnerId);
  }

  get isUsingDrivewealthAsInvestmentProvider () {
    if (!this.partnerStore.investmentThresholdLoaded) {
      return false;
    }
    return this.partnerStore.hasDrivewealthAsInvestmentProvider(this.partnerId);
  }

  get cardSettingsEnabled () {
    return !this.featureFlagStore.flags.bend21901HidePartnerDebitCardSettings;
  }

  get hasCardSettingAccess (): boolean {

    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalCardSettingsEdit) ||
        this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalCardSettingsView);
  }
}
